// Mock data for Cisco India homepage clone

export const customerLogos = [
  { name: 'United', src: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/logos/homepage/united-airlines-logo-white.svg' },
  { name: 'McLaren Mastercard Formula 1 team', src: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/logos/homepage/mclaren-logo-white.svg' },
  { name: 'Carnival', src: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/logos/homepage/carnival-logo-white.svg' },
  { name: 'Fujifilm', src: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/logos/homepage/fujifilm-logo-white.svg' },
  { name: 'STC', src: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/logos/homepage/stc-logo-white.svg' },
  { name: 'Nestle', src: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/logos/homepage/nestle-logo-white.svg' },
  { name: 'Fiserv', src: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/logos/homepage/fiserv-logo-white.svg' },
  { name: 'Workday', src: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/logos/homepage/workday-logo-white.svg' },
  { name: 'Swisscom', src: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/logos/homepage/swisscom-logo-white.svg' },
  { name: 'LiveOak Bank', src: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/logos/homepage/live-oak-bank-logo-white.svg' },
];

export const technologyTabs = [
  {
    key: 'cloud-control',
    label: 'Cloud Control',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/cloud-control-1600x900.jpg',
    title: 'Cisco Cloud Control',
    description: 'The unified platform with one shared view across every IT domain.',
    cta: 'Discover Cisco Cloud Control',
  },
  {
    key: 'agentic-ops',
    label: 'Agentic Ops',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/agentic-ops-1600x900.jpg',
    title: 'Enterprise operations at agentic AI speed',
    description: 'Move beyond visibility to autonomous operations with trusted, policy-bound agents that execute complex workflows at machine speed—while humans govern intent, policy, and risk.',
    cta: 'Discover AI Canvas',
  },
  {
    key: 'ai-networking',
    label: 'AI networking',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/ai-infrastructure-ai-networking-1600x900.jpg',
    title: 'Resilient, high-speed AI networking',
    description: 'AI-optimised networking that unifies scale, speed, and resilience—so AI workloads run faster, more efficiently, and at global scale.',
    cta: "See what's new",
  },
  {
    key: 'silicon-one',
    label: 'Silicon One',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/silicon-one-1600x900.jpg',
    title: 'Silicon to power AI-scale networking',
    description: 'Purpose-built programmable silicon powers networks with leading performance, efficiency, and scale—optimised for AI workloads across hyperscalers, service providers, enterprises, and data centres.',
    cta: 'Explore Silicon One',
  },
  {
    key: 'hybrid-mesh',
    label: 'Hybrid Mesh Firewall',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/hybrid-mesh-firewall-1600x900.jpg',
    title: 'Distributed, optimised enforcement',
    description: 'Deliver zero-trust segmentation and application protection with a highly-distributed security fabric and unified management across data centre, cloud, campus, and IoT environments.',
    cta: 'Explore Hybrid Mesh Firewall',
  },
  {
    key: 'smart-switches',
    label: 'Smart Switches',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/smart-switches-1600x900.jpg',
    title: 'Security fused into the network',
    description: 'Security is embedded at every layer of the network, scaling to support any AI application while simplifying even the most sophisticated campus and enterprise environment.',
    cta: 'Learn about Smart Switches',
  },
  {
    key: 'unified-edge',
    label: 'Unified Edge',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/unified-edge-1600x900.jpg',
    title: 'The AI-ready platform the edge demands',
    description: 'Redefine edge computing with a full-stack platform that delivers data centre performance, modularity, centralised management, and built-in security where you need it most.',
    cta: 'Discover Unified Edge',
  },
  {
    key: 'cisco-iq',
    label: 'Cisco IQ',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/cisco-iq-1600x900.jpg',
    title: 'Cisco IQ',
    description: 'Cisco IQ is the unified AI-powered experience that delivers real-time insights, assessments, troubleshooting, learning, automation, and agent-driven guidance to power Cisco support and professional services.',
    cta: 'Learn about Cisco IQ',
  },
];

export const outcomes = [
  {
    title: 'AI-ready data centers',
    description: 'Modernise and transform your data centers to power traditional and AI workloads anywhere—with speed, scale, and flexibility.',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/outcome-ai-ready-data-centers-800x450.jpg',
  },
  {
    title: 'Future-proofed workplaces',
    description: 'Create agile, resilient workplaces that evolve with employee needs and deliver incredible customer experiences everywhere.',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/outcome-future-proofed-workplace-800x450.jpg',
  },
  {
    title: 'Digital resilience',
    description: 'Keep your organisation securely up and running in the face of any disruption—from cyberattacks to third-party outages and other technical failures.',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/outcome-digital-resilience-800x450.jpg',
  },
];

export const productCategories = [
  { label: 'Networking', icon: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/icons-and-shapes/homepage/home-icon-networking.svg' },
  { label: 'Security', icon: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/icons-and-shapes/homepage/home-icon-security.svg' },
  { label: 'Observability', icon: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/icons-and-shapes/homepage/home-icon-observability.svg' },
  { label: 'Collaboration', icon: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/icons-and-shapes/homepage/home-icon-collaboration.svg' },
];

export const stats = [
  { value: '39M', label: 'Networking devices connected to our platform' },
  { value: '1B', label: 'Clients connecting monthly' },
  { value: '750B+', label: 'Security events observed daily, across networks' },
];

export const customerStories = [
  {
    heading: 'Brewing global connectivity and visibility for Nestlé',
    description: 'Nestlé depends on Cisco networking and assurance for connectivity, proactive troubleshooting, and full visibility across 1700 sites.',
    cta: 'Learn about Nestlé',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/customer-story-nestle-1200x675.jpg',
  },
  {
    heading: 'Connecting high-speed AI for the McLaren Mastercard Formula 1 Team',
    description: 'The McLaren Mastercard Formula 1 Team relies on Cisco networking and security for AI workloads processing race data, fueling 24 races worldwide.',
    cta: "See McLaren's AI advantage",
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/customer-story-mclaren-1200x675.jpg',
  },
  {
    heading: 'Charting the future of work at Tripadvisor',
    description: 'Tripadvisor uses Cisco networking and collaboration to connect global offices—powering collaborative, sustainable work worldwide.',
    cta: 'Explore Tripadvisor',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/customer-story-tripadvisor-1200x675.jpg',
  },
];

export const insideCisco = [
  {
    tag: 'Executive fireside chat',
    title: 'Cisco and OpenAI leaders discuss cyber defense in the AI era',
    cta: 'Watch the fireside chat',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/cisco-x-open-ai-jeetu-fireside-chat.jpg',
  },
  {
    tag: 'Broadcast',
    title: 'Glasswing: Mythos demands a new model for infrastructure',
    cta: 'Watch now',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/glasswing-banner-800x450.jpg',
  },
  {
    tag: 'Report',
    title: "Discover how Cisco's secure networking solutions help Indian enterprises bridge the readiness gap.",
    cta: 'Download the 2026 report',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/cisco-inside-report.jpg',
  },
  {
    tag: 'Video',
    title: 'Learn how Cisco extends Zero Trust to secure your agentic workforce',
    cta: 'Watch now',
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/2026/agentic-AI-broadcast-800x450.jpg',
  },
];

export const navItems = [
  {
    label: 'Products and Services',
    sub: ['Networking', 'Security', 'Collaboration', 'Data Center', 'Cloud', 'Observability', 'AI Infrastructure', 'IoT', 'Software'],
  },
  {
    label: 'Solutions',
    sub: ['Industries', 'Small business', 'Medium business', 'Large enterprise', 'Service providers', 'Public sector'],
  },
  {
    label: 'Learn',
    sub: ['Training and certifications', 'Cisco Learning Network', 'Webinars', 'Events', 'Blogs', 'Videos'],
  },
  {
    label: 'Support',
    sub: ['Product support', 'Software downloads', 'Documentation', 'Community', 'Contact support'],
  },
  {
    label: 'Partners',
    sub: ['Find a partner', 'Become a partner', 'Partner portal', 'Marketplace'],
  },
  {
    label: 'Explore Cisco',
    sub: ['About Cisco', 'Investors', 'Newsroom', 'Careers', 'Sustainability'],
  },
];

export const mediaSplits = [
  {
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/homepage-media-split-smb-1600x900-global.jpg',
    duration: '0:45',
    title: 'Power midsize business growth with secure AI networking',
    description: 'Are constant network and security alerts slowing down your business? Transform challenges into solutions with Cisco security and networking. Simple, secure, and scalable.',
    cta: 'Learn more',
  },
  {
    image: 'https://www.cisco.com/content/dam/cisco-cdc/site/images/photography/homepage/rtp-soc-gettycc-unlimited-2450.png',
    title: 'Powering a secure digital India',
    description: 'As India advances, we\u2019re simplifying how you secure personal data. Explore how to move from reactive compliance to proactive resilience with our latest guide.',
    cta: 'Read the whitepaper',
  },
];

export const footerColumns = [
  {
    title: 'Products and Services',
    links: ['Networking', 'Security', 'Collaboration', 'Data Center', 'Cloud', 'AI Infrastructure', 'Software', 'View all products'],
  },
  {
    title: 'Support',
    links: ['Contact us', 'Downloads', 'Documentation', 'Community', 'DevNet', 'Feedback'],
  },
  {
    title: 'Learn',
    links: ['Training and certifications', 'Webinars', 'Events', 'Blogs', 'Newsroom', 'Video portal'],
  },
  {
    title: 'Company',
    links: ['About Cisco', 'Investor relations', 'Corporate social responsibility', 'Environmental sustainability', 'Trust Center', 'Careers'],
  },
];
